import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, PageService, ParserService, TranslateService} from '@gallaghercp/core-frontend';
import {ClientService} from "../../services/client.service";

@Component({
    standalone: false,
    selector: 'core-block-cloud-video-cta',
    templateUrl: './block-cloud-video-cta.component.html',
})

export class BlockCloudVideoCtaComponent extends BlockAbstractComponent implements OnInit {

    currentLang: string | undefined;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
        protected client: ClientService,
        public override translateService: TranslateService,
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }
    parseImagePath(blockImagePath: string) {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            return 'url(https://benefits.paloaltonetworks.com' + blockImagePath + ')'
        } else {
            return 'url(' + blockImagePath + ')'
        }
    }

    override ngOnInit(): void {
        this.currentLang = this.getCurrentLanguage();
        this.client.$languageChange.subscribe(value => {
            this.currentLang = value;
        });
    }

    override ngOnDestroy() {
        if (this.client.$languageChange) {
            this.client.$languageChange.unsubscribe();
        }
    }

    getCurrentLanguage(): string {
        return <string>this.translateService.getCurrentLanguage();
    }
}
